import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { EditIconSVGComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/edit-icon-svg/edit-icon-svg.component';
import { CautionColorSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/caution-color-svg/caution-color-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { UserDetailsService } from './../../../../../_services/profile-settings/user-details.service';
import { Component, OnInit } from '@angular/core';

import { Router , RouterModule } from '@angular/router';
import { AlertService } from '@mapfre-design-library/src/public_api';
import { ChangeProfileEmailService } from '../../../../../_services/profile-settings/change-profile-email.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { PaperlessService } from '../../../../../_services/_iam/paperless.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { Constants } from '@models/constants';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CautionColorSvgComponent, EditIconSVGComponent, MapfreButtonComponent],
  selector: 'app-profile-email-confirm',
  templateUrl: './profile-email-confirm.component.html',
  styleUrls: ['./profile-email-confirm.component.scss'],
})
export class ProfileEmailConfirmComponent implements OnInit {
  newEmail = '';
  oldEmail: string;
  user: any;
  previousURL: any;
  loader = false;
  constructor(
    private alertService: AlertService,
    public router: Router,
    private changeProfileEmailService: ChangeProfileEmailService,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private paperlessService: PaperlessService,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  confirmNewEmail() {
    if (this.loader) {
      return false;
    }
    this.loader = true;
    this.changeProfileEmailService
      .changeAccountEmail(this.oldEmail, this.newEmail)
      .subscribe(
        (resp) => {
          this.loader = false;
          this.reSync(this.newEmail, resp);
        },
        (error) => {
          this.loader = false;
          if (error.status) {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
  }

  cancel(): void {
    this.changeProfileEmailService.clearEmail();
    this.changeProfileEmailService.clearProcess();
    if (this.previousURL === Constants.BILLING_PAPERLESS) {
      this.router.navigate([Constants.BILLING_PAPERLESS]);
    } else {
      this.router.navigate(['/profile']);
    }
  }

  reSync(email, resp): void {
    this.storageService.setUserStorage(email, resp);
    this.userDetailsService.getUserDetailsByEmail().subscribe(
      () => {
        if (this.previousURL === Constants.BILLING_PAPERLESS) {
          this.alertService.success('EMAIL_SUCCESSFULLY_CHANGED', true);
          this.router.navigate([Constants.BILLING_PAPERLESS]);
        } else {
          this.alertService.success('EMAIL_UPDATE_SUCCESSFUL', true);
          this.router.navigate(['/profile']);
        }
      },
      (error) => {
        this.errorRedirectionService.errorRedirectHandler(error);
      }
    );
  }

  ngOnInit() {
    this.previousURL = this.paperlessService.getCurrentRoute();
    this.oldEmail = this.storageService.getUserFromStorage();
    this.changeProfileEmailService.$email.subscribe((emailObject) => {
      this.newEmail = emailObject;
    });
  }


}
